import { CourseStatus } from "@/lib/constants";

/**
 * CMS "hide from draft viewers" toggle: when set on a course, the
 * draft_viewers allowlist is negated for that course — everyone (including
 * allowlisted viewers) only sees its Published content. Mirrors the same
 * check in the search/sidebar/lesson-page RPCs.
 */
export function courseHiddenFromDraftViewers(
  metadata?: { hide_from_draft_viewers?: boolean } | null,
): boolean {
  return metadata?.hide_from_draft_viewers === true;
}

/** Per-course effective min status: flagged courses are Published-only for everyone. */
export function effectiveMinStatusForCourse(
  baseMinStatus: number,
  metadata?: { hide_from_draft_viewers?: boolean } | null,
): number {
  return courseHiddenFromDraftViewers(metadata)
    ? CourseStatus.Published
    : baseMinStatus;
}
